// Smooth scroll
document.addEventListener('DOMContentLoaded', function() {
    const anchors = document.querySelectorAll('a[href^="#"]');
    anchors.forEach(function(anchor) {
      anchor.addEventListener('click', function(event) {
        event.preventDefault();
        const target = anchor.getAttribute('href').substring(1);
        smoothScroll(target);
      });
    });
});

// Slide anchors menu
const slidesContainer = document.querySelector(".blog-nav .ul-clear");
const slide = document.querySelector(".blog-nav .ul-clear li");
const prevButton = document.getElementById("slide-arrow-prev");
const nextButton = document.getElementById("slide-arrow-next");

nextButton.addEventListener("click", (event) => {
  const slideWidth = slide.clientWidth;
    slidesContainer.scrollLeft += slideWidth;
});

prevButton.addEventListener("click", () => {
  const slideWidth = slide.clientWidth;
  slidesContainer.scrollLeft -= slideWidth;
});

// Init slick on mobile
$(function(){
  if (window.screen.width <= 576){
    $('.blog__items').slick({
        arrows: false,
    });
  }
  
});


/////////////////////////////////////////////////////

function smoothScroll(target) {
    const element = document.getElementById(target);
    if (element) {
      window.scrollTo({
        top: element.offsetTop - 92,
        behavior: 'smooth'
      });
    }
}